import React from 'react'
import Header from '../Layout/Header'
import Footer from '../Layout/Footer'

function Blog() {
  return (
    <div>
        <Header />
         {/* <!-- Breadcrumb Section Start --> */}
        <div class="gt-breadcrumb-wrapper bg-cover" style={{
    backgroundImage: "url('/assets/img/breadcrumb-bg.jpg')",
}}
>
            <div class="container">
                <div class="gt-page-heading">
                    <div class="gt-breadcrumb-sub-title">
                        <h1 class="wow fadeInUp" data-wow-delay=".3s">Blog Standard</h1>
                    </div>
                    <ul class="gt-breadcrumb-items wow fadeInUp" data-wow-delay=".5s">
                        <li>
                            <a href="index-2.html">
                                Home
                            </a>
                        </li>
                        <li>
                            <i class="fa-solid fa-chevron-right"></i>
                        </li>
                        <li>
                          Blog Standard
                        </li>
                    </ul>
                </div>
            </div>
        </div>

         {/* <!-- GT News-standard Section Start --> */}
        <section class="news-standard-section section-padding">
            <div class="container">
                <div class="gt-news-standard-wrapper">
                    <div class="row g-4">
                        <div class="col-12 col-lg-8">
                            <div class="gt-news-standard-items">
                                <div class="gt-news-card-items-4">
                                    <div class="gt-news-image">
                                        <img src="/img/prop.png" alt="img"/>
                                    </div>
                                    <div class="gt-news-content">
                                       <ul class="gt-date-list">
                                            <li>
                                                <i class="fa-solid fa-calendar-days"></i>
                                                11 March 2025
                                            </li>
                                            <li>
                                                <i class="fa-solid fa-comments"></i>
                                                19 Comments
                                            </li>
                                       </ul>
                                       <h3>
                                        <a href="news-details.html">
                                            Interior Design Ideas to Elevate Your Living Space
                                        </a>
                                    </h3>
                                       <p>
                                       Discover smart interior design tips that transform your home into a stylish sanctuary. From lighting and layout to colors and textures—create a space that reflects comfort and elegance.
                                       </p>
                                      <a href="news-details.html" class="theme-btn">Read More <i class="flaticon-right-arrow"></i></a>
                                    </div>
                                </div>
                                <div class="gt-news-card-items-4">
                                    <div class="gt-news-image">
                                        <img src="assets/img/home-1/news/news-11.jpg" alt="img"/>
                                    </div>
                                    <div class="gt-news-content">
                                       <ul class="gt-date-list">
                                            <li>
                                                <i class="fa-solid fa-calendar-days"></i>
                                                11 March 2025
                                            </li>
                                            <li>
                                                <i class="fa-solid fa-comments"></i>
                                                19 Comments
                                            </li>
                                       </ul>
                                       <h3>
                                        <a href="news-details.html">
                                           How to Stage Your Home for a Quick Sale
                                        </a>
                                    </h3>
                                       <p>
                                        Maximize your home’s appeal with simple staging tips—declutter, enhance lighting, add neutral decor, and highlight key features to attract buyers quickly and increase your chances of a fast sale.
                                       </p>
                                       <a href="news-details.html" class="theme-btn">Read More <i class="flaticon-right-arrow"></i></a>
                                    </div>
                                </div>
                                <div class="gt-news-card-items-4 mb-0">
                                    <div class="gt-news-image">
                                        <img src="assets/img/home-1/news/news-12.jpg" alt="img"/>
                                    </div>
                                    <div class="gt-news-content">
                                       <ul class="gt-date-list">
                                            <li>
                                                <i class="fa-solid fa-calendar-days"></i>
                                                11 March 2025
                                            </li>
                                            <li>
                                                <i class="fa-solid fa-comments"></i>
                                                19 Comments
                                            </li>
                                       </ul>
                                       <h3>
                                        <a href="news-details.html">
                                         How Real Estate Investments Can Build Wealth
                                        </a>
                                    </h3>
                                       <p>
                                       Real estate investments offer long-term financial growth through rental income, property appreciation, and tax benefits. Build wealth steadily with smart property choices and passive income opportunities over time.
                                       </p>
                                       <a href="news-details.html" class="theme-btn">Read More <i class="flaticon-right-arrow"></i></a>
                                    </div>
                                </div>
                                <div class="page-nav-wrap text-center">
                                    <ul>
                                        <li><a class="page-numbers" href="#"><i class="fa-solid fa-chevron-left"></i></a></li>
                                        <li class="active"><a class="page-numbers" href="#">01</a></li>
                                        <li><a class="page-numbers" href="#">02</a></li>
                                        <li><a class="page-numbers" href="#">03</a></li>
                                        <li><a class="page-numbers" href="#"><i class="fa-solid fa-chevron-right"></i></a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-12">
                            <div class="gt-main-sideber sticky-style">
                                <div class="gt-single-sideber-widget">
                                    <div class="gt-widget-title">
                                        <h3>All Categories</h3>
                                    </div>
                                    <ul class="gt-category-list">
                                        <li><a href="news-details.html">City Guide</a><span><i class="flaticon-right-arrow"></i></span></li>
                                        <li><a href="news-details.html">New Places</a><span><i class="flaticon-right-arrow"></i></span></li>
                                        <li><a href="news-details.html">Apartments </a><span><i class="flaticon-right-arrow"></i></span></li>
                                        <li><a href="news-details.html">Real estate  </a><span><i class="flaticon-right-arrow"></i></span></li>
                                        <li><a href="news-details.html">Luxury vilas  </a><span><i class="flaticon-right-arrow"></i></span></li>
                                    </ul>
                                </div>
                                <div class="gt-single-sideber-widget">
                                    <div class="gt-widget-title">
                                        <h3>Recent Post</h3>
                                    </div>
                                    <div class="gt-recent-post-area">
                                        <div class="gt-recent-items">
                                            <div class="gt-recent-thumb">
                                                <img src="assets/img/home-1/news/post-1.jpg" alt="img"/>
                                            </div>
                                            <div class="gt-recent-content">
                                                <h5>
                                                    <a href="news-details.html">
                                                        What to Know About Property Taxes Before You Buy
                                                    </a>
                                                </h5>
                                                <ul>
                                                    <li>
                                                        March 26, 2025
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="gt-recent-items">
                                            <div class="gt-recent-thumb">
                                                <img src="/img/new2.jpeg" alt="img"/>
                                            </div>
                                            <div class="gt-recent-content">
                                                <h5>
                                                    <a href="news-details.html">
                                                       Simple Home Upgrades That Boost Property Value
                                                    </a>
                                                </h5>
                                                <ul>
                                                    <li>
                                                        March 26, 2025
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="gt-recent-items">
                                            <div class="gt-recent-thumb">
                                                <img src="/img/new2.jpeg" alt="img"/>
                                            </div>
                                            <div class="gt-recent-content">
                                                <h5>
                                                    <a href="news-details.html">
                                                       What to Know About Property Taxes Before You Buy
                                                    </a>
                                                </h5>
                                                <ul>
                                                    <li>
                                                        March 26, 2025
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="gt-single-sideber-widget mb-0">
                                    <div class="gt-widget-title">
                                        <h3>Popular Tags</h3>
                                    </div>
                                    <div class="tagcloud">
                                        <a href="news-details.html">SmartHomes</a>     
                                        <a href="news-details.html">GreenLiving</a>
                                        <a href="news-details.html">LuxuryLiving</a>
                                        <a href="news-details.html">LegalAdvice</a>
                                        <a href="news-details.html">RealEstateTrends</a>
                                        <a href="news-details.html">HouseHunting</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
<Footer />
    </div>
  )
}

export default Blog